import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from '@mantine/core';

import styles from './Dropdown.module.css';

import type { SelectProps } from '@mantine/core';

export const Dropdown = (props: SelectProps) => (
  <Select rightSection={<FontAwesomeIcon className={styles.icon} icon={faSortDown} size='xs' />} {...props} />
);
